document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.js-toggle-form').forEach(function (formToggle) {
        formToggle.addEventListener('click', function () {

            document.querySelector('.js-show-form').classList.add('is-active');

            document.querySelectorAll('.js-hide-content').forEach(function (hideContent) {
                hideContent.classList.remove('is-active');
            })


        });
    })

    document.querySelectorAll('.js-toggle-show').forEach(function (infoShow) {
        infoShow.addEventListener('click', function () {

            document.querySelector('.js-show-form').classList.remove('is-active');

            document.querySelectorAll('.js-hide-content').forEach(function (hideContent) {
                hideContent.classList.add('is-active');
            })


        });
    })

})
